import * as React from "react";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
const locationDetails = [{
  icon: MapPin,
  label: "Address",
  value: "123 Pet Care Lane, Sunnyvale, CA 94087"
}, {
  icon: Phone,
  label: "Phone",
  value: "(555) 123-4567"
}, {
  icon: Mail,
  label: "Email",
  value: "hello@happypaws.vet"
}, {
  icon: Clock,
  label: "Hours",
  value: "Mon-Fri: 8am-7pm | Sat: 9am-4pm"
}];
export default function FindUs() {
  return <section data-section-id="241624" id="find-us" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-4 tracking-tight">
            Visit Happy Paws
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-lg">
            Our modern clinic is designed to be a stress-free environment for your beloved pets. Come meet our friendly veterinary team.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          {}
          <div className="relative w-full min-h-[400px] lg:min-h-[500px] rounded-3xl overflow-hidden shadow-xl border border-border/50 bg-muted">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/veterinary_clinic_map_location.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/veterinary_clinic_map_location.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/veterinary_clinic_map_location.png-wvc-sizes" alt="Map showing the location of Happy Paws Animal Hospital" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            {}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="bg-primary text-primary-foreground p-4 rounded-lg shadow-2xl ring-4 ring-primary/20">
                <MapPin className="size-8" />
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            <Card className="h-full flex flex-col justify-between border-border/60 shadow-lg bg-card rounded-3xl">
              <CardHeader className="pb-4">
                <CardTitle className="text-2xl md:text-3xl font-default font-semibold text-card-foreground">
                  Clinic Information
                </CardTitle>
                <CardDescription className="font-default text-base mt-2">
                  We provide ample parking and a welcoming lobby for you and your pet.
                </CardDescription>
              </CardHeader>
              
              <CardContent className="flex-grow">
                <Table>
                  <TableBody>
                    {locationDetails.map((detail, i) => <TableRow key={i} data-index={i} className="border-border/40 hover:bg-transparent">
                        <TableCell className="font-medium text-muted-foreground w-1/3 align-top py-4 pl-0">
                          <div className="flex items-center gap-3">
                            <div className="bg-accent p-2 rounded-lg text-accent-foreground">
                              <detail.icon className="size-4" />
                            </div>
                            <span className="font-default">{detail.label}</span>
                          </div>
                        </TableCell>
                        <TableCell className="text-foreground font-default py-4 pr-0 text-right md:text-left">
                          {detail.value}
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </CardContent>

              <CardFooter className="pt-6 pb-8">
                <Button asChild size="lg" className="w-full text-lg font-default h-14 shadow-md hover:shadow-lg transition-all rounded-lg bg-primary hover:bg-primary/90">
                  <Link to="https://maps.google.com/?q=123+Pet+Care+Lane,+Sunnyvale,+CA+94087" newTab>
                    <Navigation className="mr-2 size-5" />
                    Get Directions
                  </Link>
                </Button>
              </CardFooter>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}